"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Log = _interopRequireDefault(require("./Log"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var withDeprecationNotice = function withDeprecationNotice(WrappedComponent, label) {
  _Log["default"].warn(label);
  return WrappedComponent;
};
var _default = exports["default"] = withDeprecationNotice;